import React from 'react';

interface KpiIconsProps {
  kpis: string[] | { values: string[] };
  size?: 'sm' | 'md';
}

const KpiIcons: React.FC<KpiIconsProps> = ({ kpis, size = 'sm' }) => {
  // Define KPI groups based on the config
  const kpiGroups = {
    meritvarde: {
      icon: '📊',
      title: 'Meritvärde',
      color: 'bg-blue-100 text-blue-700 border border-blue-200',
      kpis: ['N15504']
    },
    betygskriterier: {
      icon: '✅',
      title: 'Betygskriterier',
      color: 'bg-green-100 text-green-700 border border-green-200',
      kpis: ['N15418']
    },
    behorighet: {
      icon: '🎓',
      title: 'Behörighet',
      color: 'bg-purple-100 text-purple-700 border border-purple-200',
      kpis: ['N15436']
    },
    amnen6: {
      icon: '6️⃣',
      title: 'Ämnen åk 6',
      color: 'bg-orange-100 text-orange-700 border border-orange-200',
      kpis: ['N15482', 'N15488', 'N15516', 'N15485'] // Engelska, Svenska, SVA, Matematik
    },
    amnen9: {
      icon: '9️⃣',
      title: 'Ämnen åk 9',
      color: 'bg-red-100 text-red-700 border border-red-200',
      kpis: ['N15494', 'N15502', 'N15548', 'N15497'] // Engelska, Svenska, SVA, Matematik
    }
  };

  const iconSize = size === 'sm' ? 'w-5 h-5' : 'w-6 h-6';
  const textSize = size === 'sm' ? 'text-xs' : 'text-sm';

  // Handle both array and object with values property
  let kpiArray: string[] = [];
  if (Array.isArray(kpis)) {
    kpiArray = kpis;
  } else if (kpis && typeof kpis === 'object' && 'values' in kpis && Array.isArray(kpis.values)) {
    kpiArray = kpis.values;
  }
  
  if (!kpiArray || kpiArray.length === 0) {
    return null;
  }

  // Check which groups have at least one KPI with data
  const availableGroups = Object.entries(kpiGroups).filter(([_, group]) => 
    group.kpis.some(kpiId => kpiArray.includes(kpiId))
  );

  if (availableGroups.length === 0) {
    return null;
  }

  return (
    <div className="flex items-center gap-1">
      {availableGroups.map(([groupKey, group]) => (
        <span
          key={groupKey}
          className={`inline-flex items-center justify-center ${iconSize} rounded-full ${group.color} ${textSize} shadow-sm`}
          title={group.title}
        >
          {group.icon}
        </span>
      ))}
    </div>
  );
};

export default KpiIcons;
